export default "__VITE_ASSET__DjmUyaMq__"